import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function Footer({ light }) {
  return (
    <Box component="footer" py={2} textAlign="center">
      <Typography variant="caption" color={light ? "#fff" : "text.secondary"}>
        © {new Date().getFullYear()} Convokko · Digitaliza tu escuela
      </Typography>
    </Box>
  );
}

Footer.defaultProps = {
  light: false,
  sidebarOpen: false,
};

Footer.propTypes = {
  light: PropTypes.bool,
  sidebarOpen: PropTypes.bool,
};

export default Footer;
